import { styled } from "@linaria/react"

const Button = styled.button`
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 0.5rem !important;

  font-size: inherit;
  color: inherit;

  background-color: var(--mui-palette-background-default);
  padding: 0.57rem 0.9rem;
  outline: none;
  cursor: pointer;
  transition: all 0.17s ease !important;
  border: 0;
  border-radius: var(--mui-shape-borderRadius);

  svg {
    font-size: 1rem;
    width: 1.25em;
    height: 1.25em;
  }

  &:hover:not(:disabled) {
    opacity: 0.8;
    transform: none !important;
  }

  &:disabled {
    opacity: 0.75;
    cursor: not-allowed;
  }

  &.outlined {
    border: 1px solid var(--mui-palette-borderPrimary);
    background-color: var(--mui-palette-background-default) !important;
    color: var(--mui-palette-text-primary) !important;
  }

  &.secondary {
    background-color: var(--mui-palette-secondary-main) !important;
    color: #fff !important;
  }

  &.accent {
    background-color: rgb(var(--theme-color)) !important;
    color: #fff !important;
  }
`

export default Button
